import kitopiCoin from '@/assets/images/KitoCoin.webp';
import { useCurrency } from '@/context/CurrencyContext/CurrencyContext';
import { useFeatureFlagValue } from '@/hooks/useFeatureFlag';
import styles from './CashbackStreakPill.module.scss';

const CashbackStreakPill = () => {
  const streakBannerValue = useFeatureFlagValue('streak-banner');
  const { currencySymbol } = useCurrency();
  return (
    <div
      className={styles.cashbackStreakPillRoot}
      role="img"
      aria-label={`Cashback reward: ${streakBannerValue || '0'} ${currencySymbol}`}
    >
      <div className={styles.kitopiCoinWrapper}>
        <img src={kitopiCoin} alt="Kitopi coin icon" className={styles.kitopiCoin} />
      </div>
      <span aria-label="Cashback amount">
        {currencySymbol} {streakBannerValue || '0'}
      </span>
    </div>
  );
};

export default CashbackStreakPill;
